module.exports = __webpack_public_path__ + "img/header.595b67fc.jpg";